module.exports = __webpack_public_path__ + "img/novelty-msg.66338075.png";